/* eslint-disable no-invalid-this */
/* eslint-disable func-style */
/* eslint-disable no-use-before-define */

/** @type {PaginationModuleState} */
export const paginationState = {
  meta: {}
}

/** @type {PaginationGetterTree} */
export const paginationGetters = {
  isLastPage: (state) => {
    return isLastPage.call(state)
  },
  currentPage: (state) => {
    return currentPage.call(state)
  },
  paginationLinks: (state) => {
    return paginationLinks.call(state)
  }
}

/** @type {PaginationMutationTree} */
export const paginationMutations = {
  setPaginationData: (state, meta) => {
    setPaginationData.call(state, meta)
  }
}

export function isLastPage() {
  return this.meta.current_page === this.meta.last_page
}

export function currentPage() {
  return this.meta.current_page
}

export function paginationLinks() {
  return this.meta.links
}

export function setPaginationData(meta) {
  this.meta = { ...meta }
}
